<template>
  <div class="wrap data-management material-main" ref="scrollBody" id="scrollBody">
    <div class="content--options" id="contentOptions">
      <operation-select-major
        @change="majorChangeFn"
        parentRegion="material"
        @operateMoreMajor="calcTableHeight"
        :refresh-region-list="refreshRegionList"
      ></operation-select-major>
      <div ref="scrollList" class="list" :style="{'height': isFixed?'91px':''}">
        <div :class="{'fixed':isFixed, 'fold-menu': foldMenu}">
          <!-- 按钮组 -->
          <operation-buttons
            :button-list="buttonList"
            @clickHandle="topButtonClick"
            origin="database"
            @uploadHandle="uploadHandle"
            type="material"
            :disabled-button="disabledButton"
            :tip-content="tipContent"
            class="float_left"
          ></operation-buttons>
          <!-- 高级搜索 -->
          <dialog-senior-search
            class="float_right"
            page="material"
            :key="resetSelectAll"
            @onSearch="seniorSearchHandle"
          ></dialog-senior-search>
          <!-- 搜索 -->
          <operation-search :key="resetSelectAll" class="float_right"
                            @onSearch="searchHandle" placeholder="请输入名称或规格型号">
          </operation-search>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="tree-table fit flex flex-column table-medium table-beyond-hiding" :style="{height: tableHeight + 'px'}" id="tree-table">
      <div class="header-wrapper" ref="headerWrapper">
        <div class="table-header flex flex-row" :style="{width: (scrollY ? (tableWidth + 17) : tableWidth) + 'px'}">
          <div class="header-item is-leaf is-center" style="width: 40px;">
            <label>
              <!-- 表头那个全选 下拉框 -->
              <select-all
                :reset-select-all="resetSelectAll"
                :current-page-item-count="dataList.length"
                :current-page-item-selected="selectItems.length"
                :pageTotal="Math.ceil(total/parameter.pageSize)"
                :top="31"
                :left="-6"
                @change="selectAllChange"
              ></select-all>
            </label>
          </div>
          <div class="header-item is-leaf is-left" style="width: 80px;">编码</div>
          <div class="header-item is-leaf is-center flex-1">名称</div>
          <div class="header-item is-leaf is-center" style="width: 80px;">规格型号</div>
          <div class="header-item is-leaf is-center" style="width: 60px;">单位</div>
          <template v-if="regionSpecial[region]">
            <div class="header-item is-leaf is-right" style="width: 80px;" v-if="regionSpecial[region].marketRate">{{regionSpecial[region].marketRate.name}}(元)</div>
            <div class="header-item is-leaf is-right" style="width: 88px;" v-if="regionSpecial[region].marketPreTaxRate">{{regionSpecial[region].marketPreTaxRate.name}}(元)</div>
            <div class="header-item is-leaf is-right" style="width: 64px;" v-if="regionSpecial[region].taxRatio">{{regionSpecial[region].taxRatio.name}}(元)</div>
            <div class="header-item is-leaf is-right" style="width: 64px;" v-if="regionSpecial[region].vatResFactor">{{regionSpecial[region].vatResFactor.name}}(元)</div>
            <div class="header-item is-leaf is-right" style="width: 64px;" v-if="regionSpecial[region].psCostRatio">{{regionSpecial[region].psCostRatio.name}}(元)</div>
          </template>
          <template v-else>
            <div class="header-item is-leaf is-right" style="width: 100px;">含税市场价(元)</div>
            <div class="header-item is-leaf is-right" style="width: 120px;">不含税市场价(元)</div>
            <div class="header-item is-leaf is-right" style="width: 80px;">税率(%)</div>
          </template>
          <div class="header-item is-leaf is-left" style="width: 80px;" v-if="pageType === 'databaseBasis'">上传人</div>
          <div class="header-item is-leaf is-center" style="width: 80px;">
            <em
              class="sort-btn-fixed position-relative cursor-pointer"
              @click="changeSort('time')"
              data-type="operateTime">
              上传时间
              <i class="sort"
                 :class="parameter.timeSort === 1 ? 'sort-down': (parameter.timeSort === 0 ?'sort-up' : '')"></i>
            </em>
          </div>
          <template v-if="pageType === 'databaseBasis'">
            <div class="header-item is-leaf is-center" style="width: 100px;">数据来源</div>
            <div class="header-item is-leaf is-center" style="width: 100px;">审核人</div>
            <div class="header-item is-leaf is-center" style="width: 120px;">
              <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('inspected')">
                审核状态
                <i :class="parameter.inspectedSort === 0 ? 'sort-up' : parameter.inspectedSort === 1 ? 'sort-down' : 'sort'"></i>
              </em>
            </div>
          </template>
          <div class="header-item is-leaf is-center" style="width: 100px;"></div>
          <div class="has-gutter" v-if="scrollY"></div>
        </div>
      </div>
      <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
        <ul class="container" :style="{width: tableWidth + 'px'}" ref="containerWrapper">
          <li class="flex flex-row row row--level-1" :title="data.resCatalogName" v-for="(data, i) in dataList" :key="i">
            <template v-if="data.inspected=='true' && user.userType!=1">
              <div class="cell column_1 is-left" style="width: 20px;">
                <w-checkbox v-model="data.checked" @change="itemCheckHandle(data)"></w-checkbox>
              </div>
              <div class="cell column_2 is-left" style="width: 20px;">
                <i class="w-icon-shen" style="padding-left: 5px;color: #7db500"></i>
              </div>
            </template>
            <template v-else>
              <div class="cell column_1 is-left" style="width: 40px;">
                <w-checkbox v-model="data.checked" @change="itemCheckHandle(data)"></w-checkbox>
              </div>
            </template>
            <!--<div class="cell column_2 is-left" style="width: 8px;"></div>-->
            <div class="cell column_3 is-left" style="width: 80px;">{{data.code}}</div>
            <div class="cell column_4 is-left flex-1">{{data.description}}</div>
            <div class="cell column_5 is-left" style="width: 80px;">{{data.spec}}</div>
            <div class="cell column_6 is-center" style="width: 60px;">{{data.unit}}</div>
            <!-- 地区特性 -->
            <template v-if="regionSpecial[region]">
              <div class="cell column_7 is-right" style="width: 80px;" v-if="regionSpecial[region].marketRate">{{data.marketRate}}</div>
              <div class="cell column_8 is-right" style="width: 88px;" v-if="regionSpecial[region].marketPreTaxRate">{{!regionSpecial[region].marketPreTaxRate.value? data.marketPreTaxRate: (data.marketPreTaxRate==''||data.taxRatio)?data.marketRate:data.marketPreTaxRate }}</div>
              <div class="cell column_9 is-right" style="width: 64px;" v-if="regionSpecial[region].taxRatio">{{data.taxRatio}}</div>
              <div class="cell column_10 is-right" style="width: 64px;" v-if="regionSpecial[region].vatResFactor">{{data.vatResFactor}}</div>
              <div class="cell column_11 is-right" style="width: 64px;" v-if="regionSpecial[region].psCostRatio">{{data.psCostRatio}}</div>
            </template>
            <template v-else>
              <div class="cell column_7 is-right" style="width: 100px;">{{data.marketRate}}</div>
              <div class="cell column_8 is-right" style="width: 120px;">{{data.marketPreTaxRate}}</div>
              <div class="cell column_9 is-right" style="width: 80px;">{{data.taxRatio}}</div>
            </template>
            <template v-if="pageType === 'databaseBasis'">
              <div class="cell column_12 is-center" style="width: 120px;">{{data.authorIdStr}}</div>
            </template>
            <div class="cell column_13 is-center" style="width: 80px;">{{data.createTimeStr}}</div>
            <template v-if="pageType === 'databaseBasis'">
              <div class="cell column_14 is-center" style="width: 100px;">{{data.source}}</div>
              <div class="cell column_15 is-center" style="width: 100px;">
                <span>{{!data.inspector && +data.inspected > 0 ? '无需审核' : data.inspector}}</span>
              </div>
              <div class="cell column_16 is-center" style="width: 120px;">
                <div class="action-inspect" v-if="+data.inspected === 0">
                  <span :class="['action-accept', data.professionAllowed ? '' : 'invalid']" @click="dealItem('inspect', data, i, true)">通过</span>
                  <span :class="['action-reject', data.professionAllowed ? '' : 'invalid']" @click="dealItem('inspect', data, i, false)">不通过</span>
                </div>
                <span class="inspect-status accept" v-else-if="+data.inspected === 1">审核通过</span>
                <span class="inspect-status reject" v-else-if="+data.inspected === 2">审核未通过</span>
              </div>
            </template>
            <div class="cell column_17 is-center" style="width: 100px;">
              <el-tooltip content="修改">
                <i class="w-icon-xiugai margin-right-10 cursor-pointer" :class="[data.professionAllowed ? '' : 'invalid']"
                   @click="updataItem(i, data)"></i>
              </el-tooltip>
              <el-tooltip content="删除">
                <i class="r2-icon-action_delete_outline cursor-pointer margin-right-10" :class="[data.professionAllowed ? '' : 'invalid']"
                   @click="dealItem('delete', data)"></i>
              </el-tooltip>
              <el-tooltip content="移动到">
                <i class="w-icon-yidong cursor-pointer" :class="[data.professionAllowed ? '' : 'invalid']" @click="dealItem('move', data)"></i>
              </el-tooltip>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <simple-table :isHeight="false" v-if="false"
                  :showNoData="dataList.length === 0"
                  :is-empty="dataList.length < 1"
                  :is-scroll="false">
      <!-- 表头 -->
      <template slot="headTable">
        <div class="table-head-wrapper" :class="{'th-fixed':isFixed, 'fold-menu': foldMenu}">
          <table cellspacing="0" cellpadding="0" border="0" class="table-head">
            <thead class="has-gutter">
              <tr>
                <th width="28" class="font-left">
                  <label class="checkall-label">
                    <select-all
                      :reset-select-all="resetSelectAll"
                      :current-page-item-count="dataList.length"
                      :current-page-item-selected="selectItems.length"
                      :pageTotal="Math.ceil(total/parameter.pageSize)"
                      :top="31"
                      :left="-6"
                      @change="selectAllChange"
                    ></select-all>
                  </label>
                </th>
                <th width="8"></th>
                <th class="font-left" width="64">编码</th>
                <th class="font-center" width="200">名称</th>
                <th class="font-center" width="64">规格型号</th>
                <th class="font-center" width="32">单位</th>
                <!-- 地区特性 -->
                <template v-if="regionSpecial[region]">
                  <th
                    class="font-right"
                    width="80"
                    v-if="regionSpecial[region].marketRate"
                  >{{regionSpecial[region].marketRate.name}}(元)</th>
                  <th
                    class="font-right"
                    width="88"
                    v-if="regionSpecial[region].marketPreTaxRate"
                  >{{regionSpecial[region].marketPreTaxRate.name}}(元)</th>
                  <th
                    class="font-right"
                    width="64"
                    v-if="regionSpecial[region].taxRatio"
                  >{{regionSpecial[region].taxRatio.name}}(%)</th>
                  <th
                    class="font-right"
                    width="64"
                    v-if="regionSpecial[region].vatResFactor"
                  >{{regionSpecial[region].vatResFactor.name}}(%)</th>
                  <th
                    class="font-right"
                    width="64"
                    v-if="regionSpecial[region].psCostRatio"
                  >{{regionSpecial[region].psCostRatio.name}}(%)</th>
                </template>
                <template v-else>
                  <th class="font-right" width="80">含税市场价(元)</th>
                  <th class="font-right" width="88">不含税市场价(元)</th>
                  <th class="font-right" width="32">税率(%)</th>
                </template>

                <th class="font-left" width="80" v-if="pageType === 'databaseBasis'">上传人</th>

                <th class="font-center" width="64">
                  <em
                    class="sort-btn-fixed position-relative cursor-pointer"
                    @click="changeSort('time')"
                    data-type="operateTime">
                    上传时间
                    <i class="sort"
                      :class="parameter.timeSort === 1 ? 'sort-down': (parameter.timeSort === 0 ?'sort-up' : '')"></i>
                  </em>
                </th>

                <!-- R2  第二迭代 去掉地区列 -->
                <!--<th class="font-center" width="48">地区</th>-->

                <template  v-if="pageType === 'databaseBasis'">
                  <th class="font-left" width="100">数据来源</th>
                  <th class="font-left" width="100">审核人</th>
                  <th class="font-left" width="120">
                    <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('inspected')">
                      审核状态
                      <i :class="parameter.inspectedSort === 0 ? 'sort-up' : parameter.inspectedSort === 1 ? 'sort-down' : 'sort'"></i>
                    </em>
                  </th>
                </template>
                <th class="font-center" width="100"></th>
              </tr>
            </thead>
          </table>
        </div>
      </template>
      <!-- 表主体 -->
      <template slot="body" v-if="dataList.length>0">
        <tbody id="projectContent">
          <tr :title="data.resCatalogName" v-for="(data, i) in dataList" :key="i">
            <template v-if="data.inspected=='true' && user.userType!=1">
              <td width="20" class="font-left">
                <!--<input-->
                  <!--class="checkbox-click"-->
                  <!--v-model="data.checked"-->
                  <!--type="checkbox"-->
                  <!--style="margin-left: 3px;"-->
                  <!--@change="itemCheckHandle($event, data)"-->
                <!--/>-->
                <w-checkbox v-model="data.checked" @change="itemCheckHandle(data)"></w-checkbox>
              </td>
              <td width="8">
                <i class="w-icon-shen" style="padding-left: 5px;color: #7db500"></i>
              </td>
            </template>
            <td v-else width="28" class="font-left">
              <!--<input-->
                <!--class="checkbox-click"-->
                <!--v-model="data.checked"-->
                <!--type="checkbox"-->
                <!--@change="itemCheckHandle($event, data)"-->
              <!--/>-->
              <w-checkbox v-model="data.checked" @change="itemCheckHandle(data)"></w-checkbox>
            </td>
            <td width="8"></td>
            <td width="64" class="break-word-wrap font-left">{{data.code}}</td>
            <td width="200" class="font-center">{{data.description}}</td>
            <td width="64" class="font-center break-word-wrap">{{data.spec}}</td>
            <td width="32" class="font-center">{{data.unit}}</td>
            <!-- 地区特性 -->
            <template v-if="regionSpecial[region]">
              <td
                class="font-right"
                width="80"
                v-if="regionSpecial[region].marketRate"
              >{{data.marketRate}}</td>
              <td
                class="font-right"
                width="88"
                v-if="regionSpecial[region].marketPreTaxRate"
              >{{!regionSpecial[region].marketPreTaxRate.value? data.marketPreTaxRate: (data.marketPreTaxRate==''||data.taxRatio)?data.marketRate:data.marketPreTaxRate }}</td>
              <td
                class="font-right"
                width="64"
                v-if="regionSpecial[region].taxRatio"
              >{{data.taxRatio}}</td>
              <td
                class="font-right"
                width="64"
                v-if="regionSpecial[region].vatResFactor"
              >{{data.vatResFactor}}</td>
              <td
                class="font-right"
                width="64"
                v-if="regionSpecial[region].psCostRatio"
              >{{data.psCostRatio}}</td>
            </template>
            <template v-else>
              <td width="80" class="font-right">{{data.marketRate}}</td>
              <td width="88" class="font-right">{{data.marketPreTaxRate}}</td>
              <td width="32" class="font-right">{{data.taxRatio}}</td>
            </template>
            <td
              width="80"
              v-if="pageType === 'databaseBasis'"
              class="font-left break-word-wrap"
            >{{data.authorIdStr}}</td>

            <td width="64" class="font-center">{{data.createTimeStr}}</td>

            <!-- R2  第二迭代 去掉地区列 -->
            <!--<td width="48" class="font-center">{{data.region}}</td>-->
            <template  v-if="pageType === 'databaseBasis'">
              <td class="font-left" width="100">{{data.source}}</td>
              <td class="font-left" width="100">
                {{!data.inspector && +data.inspected > 0 ? '无需审核' : data.inspector}}
              </td>
              <td width="120" class="font-left">
                <div class="action-inspect" v-if="+data.inspected === 0">
                  <span :class="['action-accept', data.professionAllowed ? '' : 'invalid']"
                        @click="dealItem('inspect', data, i, true)">
                    通过
                  </span>
                  <span :class="['action-reject', data.professionAllowed ? '' : 'invalid']"
                        @click="dealItem('inspect', data, i, false)">
                  不通过
                </span>
                </div>
                <span class="inspect-status accept" v-else-if="+data.inspected === 1">
                审核通过
              </span>
                <span class="inspect-status reject" v-else-if="+data.inspected === 2">
                审核未通过
              </span>
              </td>
            </template>

            <td width="100" class="font-right operation">
              <span class="td-option">
                <el-tooltip content="修改">
                  <i :class="['w-icon-xiugai', data.professionAllowed ? '' : 'invalid']"
                     @click="updataItem(i, data)"></i>
                </el-tooltip>
                <el-tooltip content="删除">
                  <i :class="['r2-icon-action_delete_outline', data.professionAllowed ? '' : 'invalid']"
                     @click="dealItem('delete', data)"></i>
                </el-tooltip>
                <el-tooltip content="移动到">
                  <i :class="['w-icon-yidong', data.professionAllowed ? '' : 'invalid']" @click="dealItem('move', data)"></i>
                </el-tooltip>
              </span>
            </td>
          </tr>
        </tbody>
      </template>
      <div slot="body" class="empty-box" v-else-if="tableLoading">
        <p class="loading-text">正在加载数据...</p>
      </div>
      <!--<div slot="body" class="empty-box cursor-pointer" @click = "openHelp" v-else-if="dataList.length==0">-->
        <!--<img src="@/assets/images/default_empty.png" />-->
        <!--<p>点击这里上传您的第一条人材机数据</p>-->
      <!--</div>-->
      <template slot="no-data">
        <a href="/doc/guide_price.html" target="_blank">点击这里</a>
        上传您的第一条人材机数据
      </template>
    </simple-table>
    <!-- 移动到 弹窗 -->
    <dialog-move-to
      :show="moveTo.show"
      @submit="moveToSubmit"
      @cancel="moveTo.show = false"
      :edit-data="moveTo.data"
    ></dialog-move-to>
    <div class="page-box" v-if="total> 0">
      <w-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="parameter.pageNo"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="parameter.pageSize"
        :page-sizes="[50, 100, 150, 200]"
        :total="total"
      ></w-pagination>
    </div>
    <!-- 修改弹框 -->
    <w-dialog title="修改人材机" @close="update.show=false" :show="update.show" customClass="updata-dialog" :appendToBody="false"
              box-style="width: 800px;"
              :wallStyle="{zIndex: 1009}"
              footer-style="padding-bottom: 24px;border-top: 0;">
      <div class="updata-content">
        <table cellspacing="0" cellpadding="0" class="update-table">
          <thead>
            <tr>
              <th>编码</th>
              <th>名称</th>
              <th class="font-center">规格型号</th>
              <th class="font-center">单位</th>

              <template v-if="regionSpecial[region]">
                <th
                  class="font-right"
                  v-if="regionSpecial[region].marketRate"
                >{{regionSpecial[region].marketRate.name}}(元)</th>
                <th
                  class="font-right"
                  v-if="regionSpecial[region].marketPreTaxRate"
                >{{regionSpecial[region].marketPreTaxRate.name}}(元)</th>
                <th
                  class="font-right"
                  v-if="regionSpecial[region].taxRatio"
                >{{regionSpecial[region].taxRatio.name}}(%)</th>
                <th
                  class="font-right"
                  v-if="regionSpecial[region].vatResFactor"
                >{{regionSpecial[region].vatResFactor.name}}(%)</th>
                <th
                  class="font-right"
                  v-if="regionSpecial[region].psCostRatio"
                >{{regionSpecial[region].psCostRatio.name}}(%)</th>
              </template>
              <template v-else>
                <th class="font-right">含税市场价(元)</th>
                <th class="font-right">不含税市场价(元)</th>
                <th class="font-right">税率(%)</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <w-input size="small" type="text" class="ui-input ui-w80" v-model.trim="update.code" />
              </td>
              <td>
                <w-input size="small" type="text" class="ui-input ui-w100" v-model.trim="update.description" />
              </td>
              <td class="font-center">
                <w-input size="small" type="text" v-model.trim="update.spec" />
              </td>

              <td class="font-center">
                <input class="select-inner-text input__inner" type="text" v-model.trim="update.unit" />
                <select class="select__inner" v-model="update.unit" filterable>
                  <option v-for="(val, i) in UnitOptions" :key="i" :value="val">{{val}}</option>
                </select>
              </td>

              <template v-if="regionSpecial[region]">
                <td class="font-center" v-if="regionSpecial[region].marketRate">
                  <w-input
                    size="small"
                    type="number"
                    step="0.01"
                    v-model.trim.number="update.marketRate"
                    @change="taxChange('modifyMarketRate')"
                  />
                </td>
                <td class="font-center" v-if="regionSpecial[region].marketPreTaxRate">
                  <w-input
                    size="small"
                    type="number"
                    step="0.01"
                    v-model.trim.number="update.marketPreTaxRate"
                    @change="taxChange('modifyMarketPreTaxRate')"
                  />
                </td>
                <td class="font-right" v-if="regionSpecial[region].taxRatio">
                  <w-input
                    size="small"
                    :disabled="update.isDisableTaxRatio"
                    :class="{'input-disable':update.isDisableTaxRatio}"
                    type="number"
                    step="0.01"
                    v-model.trim.number="update.taxRatio"
                    @change="taxChange('modifyTaxRatio')"
                  />
                </td>
                <td class="font-right" v-if="regionSpecial[region].vatResFactor">
                  <w-input
                    size="small"
                    :disabled="update.isDisableTaxRatio"
                    :class="{'input-disable':update.isDisableTaxRatio}"
                    type="number"
                    step="0.01"
                    v-model.trim.number="update.vatResFactor"
                  />
                </td>
                <td class="font-right" v-if="regionSpecial[region].psCostRatio">
                  <w-input
                    size="small"
                    type="number"
                    step="0.01"
                    v-model.trim.number="update.psCostRatio"
                    @change="taxChange('modifyPSCostRatio')"
                  />
                </td>
              </template>
              <template v-else>
                <td class="font-center">
                  <w-input
                    size="small"
                    type="number"
                    step="0.01"
                    v-model.trim.number="update.marketRate"
                    @change="taxChange('modifyMarketRate')"
                  />
                </td>
                <td class="font-center">
                  <w-input
                    size="small"
                    type="number"
                    step="0.01"
                    v-model.trim.number="update.marketPreTaxRate"
                    @change="taxChange('modifyMarketPreTaxRate')"
                  />
                </td>

                <td class="font-right">
                  <w-input
                    size="small"
                    :disabled="update.isDisableTaxRatio"
                    :class="{'input-disable':update.isDisableTaxRatio}"
                    type="number"
                    step="0.01"
                    v-model.trim.number="update.taxRatio"
                    @change="taxChange('modifyTaxRatio')"
                  />
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <div slot="footer">
        <span class="error-text">{{update.error}}</span>
        <w-button type="primary" @click="updateHandle">确定</w-button>
        <w-button type="minor" @click="updateCancel">取消</w-button>
        <!--<span class="ui-btn ui-btn_blue" @click="updateHandle">确定</span>-->
        <!--<span class="ui-btn" @click="updateCancel">取消</span>-->
      </div>
    </w-dialog>
    <!-- 结果 -->
    <w-dialog @close="upload.show=!upload.show" :show="upload.show"
              footer-style="padding-bottom: 24px;border-top: 0;">
      <span class="w__dialog--title" slot="header">{{upload.title}}</span>
      <p>{{upload.text}}</p>
      <div v-if="upload.detailShow && upload.detail.length">
        <br />
        <p>未导入原因：</p>
        <p id="upload_result1">1、已存在相同数据</p>
      </div>
      <div slot="footer">
        <!--<input-->
          <!--class="ui-btn ui-btn_blue"-->
          <!--type="button"-->
          <!--value="查看详情"-->
          <!--v-if="upload.detail.length"-->
          <!--@click="showDetail"-->
        <!--/>-->
        <w-button type="primary" @click.stop.prevent="showDetail" v-if="upload.detail.length">查看详情</w-button>
        <template v-if="upload.title === '复制结果'">
          <!--<input class="ui-btn" type="button" value="关闭" @click="upload.show=!upload.show" />-->
          <w-button type="minor" @click.stop.prevent="upload.show=!upload.show">关闭</w-button>
        </template>
        <template v-else>
          <w-button type="minor" @click="upload.show=!upload.show">继续导入</w-button>
          <w-button type="minor" @click="upload.show=!upload.show">结束导入</w-button>
          <!--<input class="ui-btn" type="button" value="继续导入" @click="upload.show=!upload.show" />-->
          <!--<input class="ui-btn" type="button" value="结束导入" @click="upload.show=!upload.show" />-->
        </template>
      </div>
    </w-dialog>
    <w-backtotop
      scroll-el="scrollBody"
      transition-name="bottomToTop"
      hover-text="返回顶部"
      hover-class="hover-class"
      :back-position="0"
      :visibility-height="110"
      icon-name="w-icon-xiala-copy icon-demo"
      custom-class="demo-3-class"
    ></w-backtotop>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {
  OperationSelectMajor,
  DialogSeniorSearch,
  OperationButtons,
  OperationSearch,
  SelectAll,
  Collapse,
  DialogMoveTo,
  SimpleTable
} from '@/components/common'
import MaterialService from '@/assets/service/material'
import { getCookie } from '@/assets/utils/CommonUtil'
import {on, off} from '@/assets/utils'
import databaseBasisMixin from '@/assets/mixins/database-basis'

const UnitOptions = [
  'm',
  'm2',
  'm3',
  '台班',
  '工日',
  't',
  'kg',
  '座',
  '组',
  '宗',
  '元',
  '套',
  '台',
  '千米',
  '千克',
  '辆',
  '块',
  '公斤',
  '付',
  '处',
  '部',
  '10t',
  '10m2',
  '10m3',
  '10m',
  '100m2',
  '100m3',
  '100m',
  '1000块',
  '立方米',
  '平方米',
  '株',
  '千块'
]
const regionSpecial = {
  // 市场价
  安徽: {
    marketRate: {
      name: '市场价'
    }
  },
  重庆: {
    marketRate: {
      name: '市场价'
    }
  },
  贵州: {
    marketRate: {
      name: '市场价'
    }
  },
  河北: {
    marketRate: {
      name: '市场价'
    },
    vatResFactor: {
      name: '除税系数'
    }
  },
  吉林: {
    marketRate: {
      name: '市场价'
    }
  },
  陕西: {
    marketRate: {
      name: '市场价'
    }
  },
  深圳: {
    marketRate: {
      name: '市场价'
    }
  },
  云南: {
    marketPreTaxRate: {
      name: '不含税市场价',
      value: true
    }
  },
  // 特殊
  湖北: {
    marketRate: {
      name: '含税市场价'
    },
    marketPreTaxRate: {
      name: '不含税市场价'
    },
    taxRatio: {
      name: '调整系数'
    }
  },
  江苏: {
    marketRate: {
      name: '含税市场价'
    },
    marketPreTaxRate: {
      name: '不含税市场价'
    },
    taxRatio: {
      name: '调整系数'
    },
    psCostRatio: {
      name: '采保费率'
    }
  },
  江西: {
    marketRate: {
      name: '含税市场价'
    },
    marketPreTaxRate: {
      name: '不含税市场价'
    },
    taxRatio: {
      name: '进项税率'
    }
  },
  天津: {
    marketRate: {
      name: '含税市场价'
    },
    marketPreTaxRate: {
      name: '不含税市场价'
    },
    taxRatio: {
      name: '税率/调整系数'
    }
  }
}
export default {
  name: 'DatabaseMaterial',
  components: {
    DialogSeniorSearch,
    OperationButtons,
    OperationSearch,
    OperationSelectMajor,
    SelectAll,
    Collapse,
    DialogMoveTo,
    SimpleTable
  },
  mixins: [databaseBasisMixin],
  data () {
    return {
      tableWidth: 0,
      scrollY: false,
      seniorSearchForm: {}, // 高级搜索 条件暂存
      refreshRegionList: 0,
      tableLoading: false,
      regionSpecial, // 地区表头
      resetSelectAll: 0,
      isFixed: false,
      buttonList: ['upload', 'export', 'copyToCompanySpace', 'move', 'inspectBatch', 'delete'],
      UnitOptions,
      update: {
        // 人材机数据修改
        index: -1,
        show: false,
        unit: '',
        taxRatio: '',
        marketPreTaxRate: '',
        marketRate: '',
        code: '',
        description: '',
        spec: '',
        psCostRatio: '',
        vatResFactor: '',
        error: '',
        catalogIdGuid: '',
        isDisableTaxRatio: false
      },
      upload: {
        // 更新&复制
        show: false,
        text: '',
        title: '',
        detail: [],
        detailShow: false
      },
      moveTo: {
        // 移动到
        show: false, // 弹窗显示
        data: {
          chapterSelect: '',
          professionSelect: ''
        }
      },
      selectPage: '', // 全选下拉框 已选中的值 current: 当前页、all: 所有页
      operateCurrentRow: false,
      dataList: [], // 人材机数据列表
      parameter: {
        // 检索信息
        authorId: null, // 上传人ID
        code: null, // code
        description: null, // 名称
        inspected: null, // 是否审查，true：审查，false：不审查
        pageNo: 1, // 页码，从 1 开始
        pageSize: 50, // 每页多少条
        profession: null, // 专业
        region: null, // 地区
        timeSort: null, // 排序顺序：1:降序，0:升序
        inspectedSort: null, // 按审核状态排序：1:降序，0:升序
        searchType: 1, // 1. 并集； 2. 交集
        spec: null // 规格
      },
      total: 0, // 总条数
      unslected: [], // 未选集合
      user: {}
    }
  },
  computed: {
    ...mapState({
      foldMenu: state => state.menus.foldMenu // 是否折叠菜单
    }),
    selectItems () {
      let selectItems = []
      this.dataList.map(item => {
        if (item.checked) {
          selectItems.push(item)
        }
      })
      return selectItems
    },
    isDisableTaxRatio () {
      return {
        resCatalogID: this.update.resCatalogID,
        unit: this.update.unit,
        code: this.update.code,
        resourceDataId: this.update.resourceDataId
      }
    },
    spaceType () {
      let type = ''
      switch (+this.userInStore.userType) {
        case 1:
          type = 'share'
          break
        case 2:
          type = 'self'
          break
        case 3:
          type = 'staff'
          break
        default:
      }
      return type
    }
  },
  watch: {
    foldMenu (newVal, oldVal) {
      if (newVal !== oldVal) {
        setTimeout(() => {
          this.calcTableHeight()
        }, 500)
      }
    },
    isDisableTaxRatio (val, oldVal) {
      let resCatalogID = val.resCatalogID
      let unit = val.unit
      if (
        resCatalogID === '5cb94a9f-169d-43de-b9a9-65199b233b88' ||
        unit === '元' ||
        unit === '%' ||
        unit === '％'
      ) {
        this.update.isDisableTaxRatio = true
      } else {
        this.update.isDisableTaxRatio = false
      }
    }
  },
  methods: {
    calcTableHeight () {
      let tableWidth = 520
      if (this.pageType === 'databaseBasis') {
        tableWidth += 400
      }
      if (this.regionSpecial[this.region]) {
        tableWidth += 360
      } else {
        tableWidth += 300
      }
      let w = this.getDomWidth('scrollBody')
      console.log(w)
      if (tableWidth < this.getDomWidth('scrollBody') - 20) {
        tableWidth = this.getDomWidth('scrollBody') - 20
      }
      if (this.scrollY) {
        tableWidth -= 17
      }
      this.tableWidth = tableWidth
      this.tableHeight = this.getTableHeight('scrollBody') - this.getTableHeight('contentOptions') - 30
    },
    // 滚动条滚动事件
    handleScroll (event) {
      this.$refs.headerWrapper.scrollLeft = this.$refs.bodyWrapper.scrollLeft
    },
    // 1. 修改专业、切换地区时 触发
    majorChangeFn (obj) {
      this.calcTableHeight()
      // 选定的地区记录到浏览器里
      sessionStorage.setItem('material_' + this.user.gldUserId, obj.region)
      this.parameter.region = obj.region
      this.parameter.profession = obj.major
      this.parameter.pageNo = 1
      this.queryMaterialList()
    },
    // 2. 搜索
    searchHandle (name) {
      this.parameter.description = name
      this.parameter.spec = name
      this.parameter.pageNo = 1
      this.queryMaterialList()
    },
    // 2.1 高级搜索
    seniorSearchHandle (obj) {
      this.parameter.description = obj.descOrSpec
      this.parameter.spec = obj.spec
      this.parameter.inspected = obj.inspected
      this.parameter.authorId = obj.authorId
      this.parameter.pageNo = 1
      this.queryMaterialList()
    },
    // 3.1上传
    uploadHandle (files, e, type) {
      // excel
      if (type === 'excel') {
        sessionStorage.setItem('databaseSpaceType', this.pageType === 'databaseBasis' ? 2 : 1)
        this.$router.push({ path: '/database/material/upload' })
      }
      // 平台接口
      if (type === 'Platform') {
        if (
          files[0].name.substring(
            files[0].name.lastIndexOf('.'),
            files[0].name.length
          ) !== '.RCJYPT'
        ) {
          this.$message.warning({
            message: '不支持此格式文件导入,请选择正确的文件'})
          return
        }
        let formData = new FormData()
        formData.append('file', files[0])
        let query = {
          userType: this.user.userType
        }

        let taskComplete = false
        const cacheKey = new Date().getTime()
        let result = null
        const afterTask = () => {
          // 进度到100%、并且有有返回数据时执行
          if (taskComplete && result) {
            if (result.code === 200) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.upload.title = '导入结果'
                  this.upload.show = true
                  this.upload.text = `人材机总条数 ${result.data.allCount} ，导入 ${result.data.importedCount}  条，未导入 ${result.data.unImportedCount} 条`
                  this.upload.detail = []
                  this.upload.detailShow = true
                  if (result.data.unImportedCount) {
                    this.upload.detail = result.data.items
                  }
                }, 300)
              })
            }
            this.refreshRegionList++
            this.topButtonClick('refresh')
          }
        }
        formData.append('cacheKey', cacheKey)

        // 上传平台接口埋点
        MaterialService.uploadMaterialItems(formData, query).then(res => {
          result = res
          afterTask()
        })
        this.getProgress('upload', '', cacheKey).then(() => {
          taskComplete = true
          afterTask()
        })
      }
    },
    // 3.3 上传结果查看详情
    showDetail () {
      var win = window.open()
      // 流使用结束后 必须要关闭
      let htmlStr = ''
      this.upload.detail.map(item => {
        if (this.upload.title === '复制结果') {
          htmlStr += `<tr>
            <td>${item.CopyCompanyDataCode}</td>
            <td>${item.CopyCompanyDataName}</td>
            <td>${!!item.CopyCompanyDataRepeat === true ? '重复' : ''}</td>
          </tr>`
        } else {
          htmlStr += `<tr>
            <td>${item.code}</td>
            <td>${item.name}</td>
            <td>${item.spec}</td>
            <td>${item.result}</td>
          </tr>`
        }
      })
      win.document.write(`<head>
        <title>${this.upload.title === '复制结果' ? '复制' : '导入'}详情</title>
        <meta http-equiv="Content-Type" content="text/html;charset=utf-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge, chrome=1">
        <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
        <style>
          *{margin:0;padding: 0;}
            .info{
              width: 1000px;
              margin: 20px auto;
            }
            table{
              border: 1px solid #ccc;
              border-collapse: collapse;
              border-spacing: 0;
              font-size: 14px;
            }
            caption{
              padding:8px 5px;
              border: 1px solid #ccc;
              border-bottom: none;
              text-align: left;
              font-size: 20px;
            }
            caption a{
              color: #2079FA;
              text-decoration: none;
              float: right;
            }
            tr{
              height: 30px;
            }
            tr:hover td{
              background-color: #E6F9FF;
            }
            th,
            td{
              padding:8px 5px;
              border: 1px solid #ccc;
              text-align: left;
            }
            th{
              background-color: #EEE;
              color: #666;
            }
          </style>
        </head>
        <body>
        <div class="info" id="___info">
          <table width="100%" cellspacing="0" cellpadding="0">
            <caption>${
  this.upload.title === '复制结果' ? '复制' : '人材机导入'
}详情<a href="javascript:window.print()">打印</a></caption>
            <thead>
              <tr>
                <th width="200">编码</th>
                <th>名称</th>
                ${this.upload.title === '复制结果' ? '' : '<th>规格型号</th>'}
                <th>未导入原因</th>
              </tr>
            </thead>
            <tbody>
            ${htmlStr}
            </tbody>
          </table>
        </div>
        <body></head>`)
      win.document.close()
    },
    // 5.0 操作统一 在这里来封装数据
    dealItem (type, item, idx, value) {
      if (item) {
        if (['inspect', 'edit', 'delete', 'move'].includes(type) && !item.professionAllowed) {
          // 单条操作 时 无权限 则直接返回
          return
        }
        this.operationBatch = false
      } else {
        if (['export', 'exportExcel'].includes(type) && this.pageType === 'databaseBasis' && this.role !== 2) {
          // 总负责人 才能导出 电子档案室的数据
          return
        }
        this.operationBatch = true
      }
      const operations = {
        edit: '修改',
        inspect: '审核',
        inspectBatch: '审核',
        delete: '删除',
        move: '移动',
        copyToCompanySpace: '复制',
        export: '导出',
        exportExcel: '导出'
      }
      let params = Object.assign({
        modelType: '_resItem',
        resItemId: '',
        description: '', //  名称
        spec: '', // 规格型号
        authorId: '', // 上传人
        inspected: '', // 审核状态
        profession: '', // 专业
        region: '', // 地区
        selectAllPages: false, // 是否全选所有页
        unSelectedIds: '', // 若全选所有页 未选择的ids
        selectCount: 0
      }, this.parameter)
      if (item) {
        params.selectCount = 1
        params.resItemId = item.resourceDataId // 人材机 id
        params.selectAllPages = false
      } else {
        // 批量操作
        params.selectAllPages = this.selectPage === 'all'
        params.resItemId = ''
        if (this.selectPage === 'all') {
          if (this.dataList.length) {
            // 批量操作 所有页面时 未选择项 id 需传递给后台
            const unSelectedIds = []
            this.unslected.forEach((row) => {
              unSelectedIds.push(row.resourceDataId)
            })
            params.unSelectedIds = unSelectedIds.join(',')
            params.selectCount = this.total - unSelectedIds.length
          }
        } else {
          // 批量操作 当前页时
          this.selectItems.forEach((row) => {
            params.selectCount++
            params.resItemId += row.resourceDataId + ','
          })
          params.resItemId = params.resItemId.replace(/,$/, '')
        }
      }
      if (!params.selectCount) {
        this.$message.info('请勾选要' + operations[type] + '的人材机数据')
        return
      }
      this.editData = params
      console.log(params)
      // return
      switch (type) {
        case 'export':
        case 'exportExcel': // 导出Excel
          this.$confirm({
            message: '确定导出勾选的人材机数据？',
            width: 400,
            submit: () => {
              this.exportMaterialList(params, type)
            },
            cancel: () => {}
          })
          break
        case 'copyToCompanySpace':this.$confirm({
          message: '确定要将勾选的人材机数据复制到电子档案室？',
          width: 400,
          submitText: '确定复制',
          submit: () => {
            this.copyMaterialList(params)
          },
          cancel: () => {}
        })
          break
        case 'delete':
          let message = '确定删除？'
          if (!item) {
            if (this.selectPage === 'all') {
              message = `确定删除所有页（共${Math.ceil(this.total / this.parameter.pageSize)}页）数据？`
            } else {
              message = '确定删除勾选的人材机数据？'
            }
          }
          this.$confirm({
            message,
            type: 'warning',
            tips: '删除后，数据将不可恢复',
            width: 370,
            dealData: params,
            submit: data => {
              this.deleteConfirm(data)
            },
            cancel: () => {},
            submitText: '确定删除'
          })
          break
        case 'move':
          let catalogIdGuid = ''
          if (item) {
            catalogIdGuid = item.resCatalogIdGuid
          } else {
            if (this.selectItems.length) {
              catalogIdGuid = this.selectItems[0].resCatalogIdGuid
            }
          }
          if (catalogIdGuid) {
            MaterialService.getCapter({catalogIdGuid}).then(res => {
              if (res.code === 200 && res.data) {
                this.moveTo.data.professionSelect = res.data.profession
                this.moveTo.data.chapterSelect = res.data.chapter
              }
            }).finally(() => {
              this.moveTo.show = true
            })
          }
          break
        case 'inspect': // 单条数据 审核
          const params1 = {
            inspection: value || false,
            resItemId: item.resourceDataId
          }
          this.loading = true
          MaterialService.inspectMaterialItem(params1).then(res => {
            if (res.code === 200){
              this.topButtonClick('refresh')
            } else {
              // +data.code === 290004 无权限操作数据时 操作失败
              this.$message.error('操作失败')
              this.loading = false
            }
          })
          break
        case 'inspectBatch':
          this.loading = true
          MaterialService.inspectBatch({inspection: true}, params).then(res => {
            if (res.code === 200){
            } else {
              // +data.code === 290004 无权限操作数据时 操作失败
              // this.$message.error('操作失败')
            }
            this.topButtonClick('refresh')
          })
          break
        default:
      }
    },
    // 5.1 导出
    exportMaterialList (params, type) {
      if (type === 'export') {
        let taskComplete = false
        const cacheKey = new Date().getTime()
        let result = null
        const afterTask = () => {
          // 进度到100%、并且有有返回数据时执行
          if (taskComplete && result) {
            if (+result.code === 200) {
              let nextParams = {
                fileName: result.data,
                token: getCookie('ZJYTOKEN')
              }
              MaterialService.exportMaterialItems(nextParams)
              this.addOperationRecords(2, params.selectCount)
            }
            this.topButtonClick('refresh')
          }
        }
        MaterialService.exportPreMaterialItems(Object.assign(params, { cacheKey })).then(res => {
          if (+res.code === 290004) {
            //  无权限操作数据 操作失败时
            if (window.exportProgressTimerEmitter){ clearTimeout(window.exportProgressTimerEmitter) }
            if (window.exportProgressTimer) {
              clearTimeout(window.exportProgressTimer) // 清除 轮询获取获取移动进度条的 计时器
            }
            this.$progress({closeAll: true}) // 关闭进度条弹窗
            // this.$message.error('操作失败')
            this.topButtonClick('refresh')
          } else {
            result = res
            afterTask()
          }
        })
        this.getProgress('export', 0, cacheKey).then(() => {
          taskComplete = true
          afterTask()
        })
      } else {
        params.userType = this.user.userType
        MaterialService.exportPreMaterialExcel(params).then(res => {
          if (+res.code === 200) {
            let nextParams = {
              fileName: res.data,
              token: getCookie('ZJYTOKEN')
            }
            MaterialService.exportMaterialExcel(nextParams)
            this.addOperationRecords(2, params.selectCount)
          }
          this.topButtonClick('refresh')
        })
      }
    },
    // 5.2 确定删除
    deleteConfirm (params) {
      MaterialService.deleteMaterialItem(params).then(res => {
        if (+res.code === 200) {
          !this.operationBatch && (this.$message.success('删除成功'))
          this.addOperationRecords(1, params.selectCount)
          this.topButtonClick('refresh')
        } else {
          // +data.code === 290004 无权限操作数据时 操作失败
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error('删除失败')
          }
        }
      }).catch(() => {})
    },
    // 5.3 移动到 确定
    moveToSubmit (data) {
      this.moveTo.show = false
      const params = Object.assign(this.editData, {
        professionSelect: data.professionSelect,
        chapterSelect: data.chapterSelect
      })
      let taskComplete = 0
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200 || (taskComplete > 1 && +result.code === -1)) {
            !this.operationBatch && (this.$message.success('移动成功'))
            setTimeout(() => {
              this.addOperationRecords(4, this.editData.selectCount)
              this.selectAllChange('', false)
            }, 1000)
          } else {
            !this.operationBatch && (this.$message.error(result.message || '移动失败'))
          }
          this.topButtonClick('refresh')
        }
      }
      MaterialService.moveMaterialItems(params).then(res => {
        if (+res.code === 290004) {
          //  无权限操作数据 操作失败时
          if (window.moveProgressTimerEmitter){ clearTimeout(window.moveProgressTimerEmitter) }
          if (window.moveProgressTimer) {
            clearTimeout(window.moveProgressTimer) // 清除 轮询获取获取移动进度条的 计时器
          }
          this.$progress({closeAll: true}) // 关闭进度条弹窗
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error('操作失败')
          }
        } else {
          result = res
          afterTask()
        }
      })
      this.getProgress('move', 0, params.modelType).then(({ hit }) => {
        taskComplete = hit
        afterTask()
      })
    },
    // 5.4 复制
    copyMaterialList (params) {
      let taskComplete = false
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.resetSelectAll++
                this.selectAllChange('', false)
                this.upload.title = '复制结果'
                this.upload.detailShow = true
                this.upload.show = true
                this.upload.text = `复制总条数 ${result.data
                  .CopyCompanyDataErr +
                result.data.CopyCompanyDataOK}， 复制成功 ${result.data.CopyCompanyDataOK}  条，复制失败  ${result.data.CopyCompanyDataErr} 条`
                this.upload.detail = []
                if (result.data.CopyCompanyDataErr > 0) {
                  this.upload.detail = result.data.ErrDetail
                }
              }, 1000)
            })
          }
          this.topButtonClick('refresh')
        }
      }
      MaterialService.copyMaterialItems(params).then(res => {
        result = res
        afterTask()
      })
      this.getProgress('copy', 1, params.modelType).then(({ hit }) => {
        taskComplete = true
        afterTask()
      })
    },
    // 4 顶部其他按钮点击
    topButtonClick (type, e) {
      console.log(type)
      switch (type) {
        case 'exportExcel': // 导出Excel
        case 'export': // 导出
        case 'copyToCompanySpace': // 复制到电子档案室
        case 'move': // 移动
        case 'inspectBatch': // 批量 审核通过
        case 'delete': // 删除
          this.dealItem(type)
          break
        case 'refresh': // 刷新
          this.selectAllChange('', false)
          this.parameter.description = ''
          this.parameter.spec = ''
          this.parameter.inspected = ''
          this.parameter.authorId = ''
          this.parameter.pageNo = 1
          this.queryMaterialList(type)
          break
        default:
      }
    },
    // 5. 全选下拉框 切换时
    selectAllChange (type, value) {
      this.operateCurrentRow = false
      this.selectPage = type
      if (!value && this.selectPage === 'all') {
        this.selectPage = ''
      }
      this.unslected = []
      this.dataList.forEach((item, idx) => {
        item.checked = value
      })
    },
    // 5.1 单个选择
    itemCheckHandle (item) {
      if (this.selectPage === 'all') {
        const index = this.unslectedHasData(item)
        if (!item.checked){
          // 将某条人材机数据 暂存到 未选择 列表中
          if (index < 0) {
            this.unslected.push(item)
          }
        } else {
          if (index > -1) {
            this.unslected.splice(index, 1)
          }
        }
      }
    },
    // 5.3 未选择是否存在data
    unslectedHasData (item) {
      let index = -1
      this.unslected.forEach((val, idx) => {
        if (val.resourceDataId === item.resourceDataId) {
          index = idx
        }
      })
      return index
    },
    // 9.1 时间排序
    changeSort (type) {
      switch (type) {
        case 'time':
          this.parameter.inspectedSort = ''
          this.parameter.timeSort = +this.parameter.timeSort === 0 ? 1 : 0
          break
        case 'inspected':
          this.parameter.timeSort = ''
          this.parameter.inspectedSort = +this.parameter.inspectedSort === 0 ? 1 : 0
          break
        default:
      }
      this.parameter.pageNo = 1
      this.queryMaterialList()
    },
    // 10.1 获取人材机数据列表
    queryMaterialList (type) {
      this.loading = true
      this.tableLoading = true
      MaterialService.queryMaterialList(this.parameter).then(res => {
        this.dataList = []
        if (type === 'refresh') {
          // 重置全选
          this.resetSelectAll++
        }
        this.tableLoading = false
        if (+res.code === 200) {
          if (!res.data.items) {
            res.data.items = []
          }
          res.data.items.map((item, i) => {
            if (this.selectPage === 'all' && this.unslectedHasData(item) === -1) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          this.dataList = this.verifyPermission(res.data.items)
          this.total = res.data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 10.2 分页
    handleCurrentChange (index) {
      this.parameter.pageNo = index
      this.queryMaterialList()
    },
    // 10.3更改页显示多少
    handlePageSizeChange (index) {
      this.parameter.pageSize = index
      this.parameter.pageNo = 1
      this.queryMaterialList()
    },
    // handleScroll() {
    //   if (this.$refs.scrollList.getBoundingClientRect().top < 56) {
    //     this.isFixed = true
    //   } else {
    //     this.isFixed = false
    //   }
    // },
    // 13.1 修改按钮
    updataItem (index, item) {
      if (!item.professionAllowed) { return }
      this.update.error = ''
      this.modifyType = ''
      this.update.index = index
      this.update.unit = this.dataList[index].unit
      this.update.marketRate = this.dataList[index].marketRate - 0
      this.update.taxRatio = this.dataList[index].taxRatio
      this.update.marketPreTaxRate = this.dataList[index].marketPreTaxRate - 0
      this.update.code = this.dataList[index].code
      this.update.description = this.dataList[index].description
      this.update.spec = this.dataList[index].spec
      this.update.psCostRatio = this.dataList[index].psCostRatio
      this.update.vatResFactor = this.dataList[index].vatResFactor
      this.update.resCatalogID = this.dataList[index].resCatalogIdGuid
      this.update.resourceDataId = this.dataList[index].resourceDataId
      // 税率、调整系数、进口项是否可编辑
      if (
        this.update.resCatalogID === '5cb94a9f-169d-43de-b9a9-65199b233b88' ||
        this.update.unit === '元' ||
        this.update.unit === '%' ||
        this.update.unit === '％'
      ) {
        this.update.isDisableTaxRatio = true
      } else {
        this.update.isDisableTaxRatio = false
      }
      this.update.show = true
    },
    // 13.2 更改税率
    taxChange (type) {
      this.update.error = ''
      let modifyMarketRate = Math.abs(this.update.marketRate)
      let modifyMarketPreTaxRate = Math.abs(this.update.marketPreTaxRate)
      let modifyTaxRatio = Math.abs(this.update.taxRatio)
      if (this.parameter.region === '江苏') {
        let modifyPSCostRatio = Math.abs(this.update.psCostRatio)
        switch (type) {
          case 'modifyMarketRate':
            this.update.marketPreTaxRate =
              (modifyMarketRate *
                (1 + (modifyPSCostRatio / 100) * (1 + modifyTaxRatio / 100))) /
              ((1 + modifyPSCostRatio / 100) * (1 + modifyTaxRatio / 100))
            break
          case 'modifyMarketPreTaxRate':
            this.update.marketRate =
              (modifyMarketPreTaxRate *
                (1 + modifyPSCostRatio / 100) *
                (1 + modifyTaxRatio / 100)) /
              (1 + (modifyPSCostRatio / 100) * (1 + modifyTaxRatio / 100))
            break
          case 'modifyTaxRatio':
            if (modifyTaxRatio > 100) {
              this.update.taxRatio = 100
              this.update.error = '税率必须在0到100之间'
            } else if (modifyTaxRatio < 0) {
              this.update.taxRatio = 0
              this.update.error = '税率必须在0到100之间'
            }
            if (this.modifyType === 'modifyMarketPreTaxRate') {
              this.update.marketRate =
                (modifyMarketPreTaxRate *
                  (1 + modifyPSCostRatio / 100) *
                  (1 + modifyTaxRatio / 100)) /
                (1 + (modifyPSCostRatio / 100) * (1 + modifyTaxRatio / 100))
            } else {
              this.update.marketPreTaxRate =
                (modifyMarketRate *
                  (1 +
                    (modifyPSCostRatio / 100) * (1 + modifyTaxRatio / 100))) /
                ((1 + modifyPSCostRatio / 100) * (1 + modifyTaxRatio / 100))
            }
            break
          case 'modifyPSCostRatio':
            if (modifyTaxRatio > 100) {
              this.update.taxRatio = 100
              this.update.error = '采保费率必须在0到100之间'
            } else if (modifyTaxRatio < 0) {
              this.update.taxRatio = 0
              this.update.error = '采保费率必须在0到100之间'
            }
            if (this.modifyType === 'modifyMarketPreTaxRate') {
              this.update.marketRate =
                (modifyMarketPreTaxRate *
                  (1 + modifyPSCostRatio / 100) *
                  (1 + modifyTaxRatio / 100)) /
                (1 + (modifyPSCostRatio / 100) * (1 + modifyTaxRatio / 100))
            } else {
              this.update.marketPreTaxRate =
                (modifyMarketRate *
                  (1 +
                    (modifyPSCostRatio / 100) * (1 + modifyTaxRatio / 100))) /
                ((1 + modifyPSCostRatio / 100) * (1 + modifyTaxRatio / 100))
            }
            break
          default:

            break
        }
      } else {
        let tianJinJixie = false
        let huBeiXishu = modifyTaxRatio || 100
        if ((this.dataList[this.update.index].resCatalogName.indexOf('所属类别：机械') > -1 ||
          this.dataList[this.update.index].resCatalogName.indexOf('所属专业：机械') > -1) &&
          this.parameter.region === '天津') {
          tianJinJixie = true
        }
        switch (type) {
          case 'modifyMarketRate':
            if (tianJinJixie) {
              this.update.marketPreTaxRate = (
                modifyMarketRate *
                (modifyTaxRatio / 100)
              ).toFixed(2)
            } else if (this.parameter.region === '湖北') {
              this.update.marketPreTaxRate =
                modifyMarketRate * (huBeiXishu / 100)
            } else {
              this.update.marketPreTaxRate = (
                modifyMarketRate /
                (1 + modifyTaxRatio / 100)
              ).toFixed(2)
            }
            break
          case 'modifyMarketPreTaxRate':
            if (tianJinJixie) {
              this.update.marketRate =
                (modifyMarketPreTaxRate / (modifyTaxRatio / 100)).toFixed(2) -
                0
            } else if (this.parameter.region === '湖北') {
              this.update.marketRate =
                modifyMarketPreTaxRate / (huBeiXishu / 100)
            } else {
              this.update.marketRate =
                (modifyMarketPreTaxRate * (1 + modifyTaxRatio / 100)).toFixed(
                  2
                ) - 0
            }
            break
          case 'modifyTaxRatio':
            if (modifyTaxRatio > 100) {
              this.update.taxRatio = 100
              switch (this.parameter.region) {
                case '湖北':
                  this.update.error = '调整系数必须大于0，小于等于100'
                  break
                case '天津':
                  this.update.error = '税率/调整系数必须在0到100之间'
                  break
                case '江西':
                  this.update.error = '进项税率必须在0到100之间'
                  break
                case '江苏':
                  this.update.error = '采保费率必须在0到100之间'
                  break
                default:
                  this.update.error = '税率必须在0到100之间'
                  break
              }
            } else if (this.parameter.region === '湖北' && modifyTaxRatio <= 0) {
              this.update.taxRatio = 0
              this.update.error = '调整系数必须大于0，小于等于100'
            } else if (this.parameter.region === '天津' && modifyTaxRatio <= 0) {
              this.update.taxRatio = 0
              this.update.error = '税率/调整系数必须在0到100之间'
              return
            } else if (this.parameter.region === '江西' && modifyTaxRatio < 0) {
              this.update.taxRatio = 0
              this.update.error = '进项税率必须在0到100之间'
            } else if (this.parameter.region === '江苏' && modifyTaxRatio < 0) {
              this.update.taxRatio = 0
              this.update.error = '采保费率必须在0到100之间'
            } else if (modifyTaxRatio < 0) {
              this.update.taxRatio = 0
              this.update.error = '税率必须在0到100之间'
            }
            if (this.modifyType === 'modifyMarketPreTaxRate') {
              if (tianJinJixie) {
                this.update.marketRate =
                  (modifyMarketPreTaxRate / (modifyTaxRatio / 100)).toFixed(2) -
                  0
              } else if (this.parameter.region === '湖北') {
                this.update.marketRate =
                  modifyMarketPreTaxRate / (huBeiXishu / 100)
              } else {
                this.update.marketRate =
                  (modifyMarketPreTaxRate * (1 + modifyTaxRatio / 100)).toFixed(
                    2
                  ) - 0
              }
            } else {
              if (tianJinJixie) {
                this.update.marketPreTaxRate = (
                  modifyMarketRate *
                  (modifyTaxRatio / 100)
                ).toFixed(2)
              } else if (this.parameter.region === '湖北') {
                this.update.marketPreTaxRate =
                  modifyMarketRate * (huBeiXishu / 100)
              } else {
                this.update.marketPreTaxRate = (
                  modifyMarketRate /
                  (1 + modifyTaxRatio / 100)
                ).toFixed(2)
              }
            }
            break
          default:
            break
        }
      }
      if (this.update.marketRate) {
        this.update.marketRate = this.update.marketRate.toFixed(2) - 0
      }
      if (this.update.marketPreTaxRate) {
        this.update.marketPreTaxRate =
          this.update.marketPreTaxRate.toFixed(2) - 0
      }
      if (this.update.taxRatio) {
        this.update.taxRatio = (this.update.taxRatio - 0).toFixed(2) - 0
      }
      if (this.update.psCostRatio) {
        this.update.psCostRatio = this.update.psCostRatio.toFixed(2) - 0
      }
      // 变量记录更改类型
      this.modifyType = type
    },
    // 13.3 确定更新
    updateHandle () {
      // 检测名称是否为空
      if (this.update.description === '') {
        this.update.error = '请输入名称'
        return
      }
      // 湖北判断   调整系数(%)=0,不提交
      if (
        this.parameter.region === '湖北' &&
        this.update.taxRatio !== '' &&
        +this.update.taxRatio === 0
      ) {
        this.update.error = '调整系数必须大于0，小于等于100'
        return
      }
      // 天津判断   =0,不提交
      if (
        this.parameter.region === '天津' &&
        this.update.taxRatio !== '' &&
        +this.update.taxRatio === 0
      ) {
        this.update.error = '税率/调整系数必须在0到100之间'
        return
      }
      // 判断是否有数据更改
      let isChanged = true
      let updateIndex = this.update.index

      if (
        this.update.unit === this.dataList[updateIndex].unit &&
        this.update.marketRate === +this.dataList[updateIndex].marketRat &&
        this.update.taxRatio === this.dataList[updateIndex].taxRatio &&
        this.update.marketPreTaxRate === this.dataList[updateIndex].marketPreTaxRate - 0 &&
        this.update.code === this.dataList[updateIndex].code &&
        this.update.description === this.dataList[updateIndex].description &&
        this.update.spec === this.dataList[updateIndex].spec &&
        this.update.psCostRatio === this.dataList[updateIndex].psCostRatio &&
        this.update.vatResFactor === this.dataList[updateIndex].vatResFactor &&
        this.update.resCatalogID === this.dataList[updateIndex].resCatalogIdGuid &&
        this.update.resourceDataId === this.dataList[updateIndex].resourceDataId
      ) {
        isChanged = false
      }
      if (!isChanged) {
        this.update.show = false
        return
      }

      let params = {
        resItemId: this.dataList[this.update.index].resourceDataId,
        code: this.update.code,
        description: this.update.description,
        spec: this.update.spec,
        marketPreTaxRate: this.update.marketPreTaxRate,
        marketRate: this.update.marketRate,
        taxRatio: this.update.taxRatio,
        psCostRatio: this.update.psCostRatio,
        vatResFactor: this.update.vatResFactor,
        unit: this.update.unit
      }
      this.update.show = false
      let index = this.update.index
      if (
        this.dataList[index].code === params.code &&
        this.dataList[index].description === params.description &&
        this.dataList[index].spec === params.spec &&
        this.dataList[index].marketPreTaxRate === params.marketPreTaxRate &&
        this.dataList[index].marketRate === params.marketRate &&
        this.dataList[index].taxRatio === params.taxRatio &&
        this.dataList[index].psCostRatio === params.psCostRatio &&
        this.dataList[index].unit === params.unit &&
        this.dataList[index].vatResFactor === params.vatResFactor
      ) {
        return
      }
      MaterialService.updateMaterialItem(params)
        .then(res => {
          if (+res.code === 200) {
            this.$message.success('修改成功')
            this.queryMaterialList()
            this.addOperationRecords(3, 1)
          } else if (+res.code === 150) {
            this.update.show = false
            this.$message.warning({
              message: '已存在相同的人材机，请重新修改人材机信息'})
          } else {
            // +data.code === 290004 无权限操作数据时 操作失败
            this.$message.error('修改失败')
          }
        }).catch(() => {
          this.$message.error('修改失败')
        })
    },
    // 13.4 取消更新
    updateCancel () {
      this.update.show = false
    }
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    // this.queryMaterialList();
    // on(this.$refs.scrollBody, 'scroll', this.handleScroll)
    on(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
    this.calcTableHeight()
    // 窗口大小改变时 触发
    this.resizeHandle.resize(() => {
      this.calcTableHeight()
    })
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  },
  beforeDestroy () {
    // off(this.$refs.scrollBody, 'scroll', this.handleScroll)
    off(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
  }
}
</script>
<style lang='less' type='text/less'>
@import './index';
.bottomToTop-enter-active,
.bottomToTop-leave-active {
  transition: opacity 0.5s;
}
.bottomToTop-enter,
.bottomToTop-leave-to {
  opacity: 0;
}
.right-content .material-main {
  .input-disable {
    cursor: not-allowed;
  }
  .table-wrapper .table-body-wrapper {
    overflow-y: hidden;
    tr {
      height: 46px;
      td {
        word-break: break-all;
      }
    }
  }
  .table-wrapper .table-head-wrapper {
    margin-right: 0;
  }
  .empty-box {
    text-align: center;
    width: 100%;
    font-size: 26px;
    color: #999;
    .loading-text {
      font-size: 12px;
      color: #666;
    }
  }
  .shen-btn {
    cursor: pointer;
    color: #ff561a;
  }
  .shen-ok {
    border-radius: 2px;
    padding: 0 3px 2px 3px;
    font-size: 12px;
    background-color: #ff561a;
    color: #fff !important;
  }
  .font-green {
    color: #00C461;
  }
  .page-box {
    position: fixed;
    bottom: 10px;
    /*width: calc(100% - 220px);*/
    /*width: calc(100% - 260px);*/
    /*min-width: 1100px;*/
    right: 10px;
  }
  .content--options {
    padding-right: 0 !important;
  }
  .th-normal {
    height: 40px;
  }
  .sanjao-group {
    position: absolute;
    right: -15px;
    bottom: -5px;
    color: #666;
    font-size: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transform: scale(0.8);
    height: 30px;
    transform: scale(0.6);
    height: 25px;
    .sanjiao {
      font-size: 8px;
    }
    .sanjiao1 {
      font-size: 8px;
    }
    .sanjiao2 {
      font-size: 8px;
      position: relative;
      top: -6px;
    }
    .active {
      color: #72a700;
    }
  }
  .position-relative {
    position: relative;
  }
  .w__dialog--header {
    font-weight: 500;
    color: #666;
  }
  .updata-dialog {
    width: 826px !important;
    .w__dialog--body {
      padding: 10px 20px;
    }
  }
  .update-table {
    table-layout: fixed;
    word-break: break-all;
    width: 100%;
    thead {
      border: 1px solid #ccc;
      th {
        padding: 12px 6px;
        background-color: #eee;
        color: #666;
        font-size: 12px;
      }
    }
    tbody {
      tr {
        &:hover {
          background: rgba(243,244,247,1);
        }
        td {
          position: relative;
          height: 40px;
          padding: 5px 6px;
          color: #333;
          font-size: 12px;
          word-wrap: break-word;
          word-break: break-all;
          box-sizing: border-box;
          input,
          select {
            width: 80%;
            border: 1px solid #ccc;
            height: 28px;
            line-height: 28px;
            background-color: #fff;
            font-size: 12px;
            color: #666;
            padding: 0 5px;
            display: inline-block;
            vertical-align: middle;
          }
          select {
            width: 90px;
            padding: 4px 3px;
            box-sizing: border-box;
          }
          .select-inner-text {
            padding: 0;
            color: #666;
            width: 58px;
            position: absolute;
            z-index: 2;
            border: none;
            top: 7px;
            left: calc(50% - 40px);
            height: 26px;
          }
        }
      }
    }
    .w__dialog--footer {
      border-top: 0;
    }
  }
  .error-text {
    color: red;
    float: left;
  }
  .w__dialog--box {
    width: 360px;
    .w__dialog--body {
      padding: 20px;
    }
  }
}
</style>
